import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { NotFoundError } from 'src/shared/error';

import type { PaginatedContextData, PaginatedData } from 'src/app/shared/contexts/asyncData';

import { TopicPetitionUpdates } from './api.graphql';
import type { TopicPetitionUpdatesQuery, TopicPetitionUpdatesQueryVariables } from './api.graphql';
import type { TopicPetitionUpdatesItem } from './types';

type TopicPetitionUpdatesApiData = PaginatedData<
	TopicPetitionUpdatesItem,
	{
		totalCount: number;
	}
>;

export type TopicPetitionUpdatesData = PaginatedContextData<TopicPetitionUpdatesApiData>;

async function getData(
	{ gql: { fetch } }: UtilityContext,
	slug: string,
	cursor?: string,
): Promise<TopicPetitionUpdatesApiData> {
	const { data } = await fetch<TopicPetitionUpdatesQuery, TopicPetitionUpdatesQueryVariables>({
		query: TopicPetitionUpdates,
		variables: { slug, cursor: cursor ?? null },
		rejectOnError: true,
	});

	if (!data.topicPage) throw new NotFoundError();

	return {
		items: data.topicPage.petitionUpdatesConnection.nodes,
		cursor: data.topicPage.petitionUpdatesConnection.pageInfo.endCursor,
		hasNextPage: data.topicPage.petitionUpdatesConnection.pageInfo.hasNextPage,
		totalCount: data.topicPage.petitionUpdatesConnection.totalCount,
	};
}

export async function getFirstPageData(utilityContext: UtilityContext, slug: string) {
	return getData(utilityContext, slug);
}

export async function getNextPageData(utilityContext: UtilityContext, cursor: string, slug: string) {
	return getData(utilityContext, slug, cursor);
}
